import { AuxiliumComponent } from "../auxilium-component";

export class DropdownItem extends AuxiliumComponent {
	static observedAttributes = ["value", "disabled", "link", "group", "suffix-icon", "icon"];

	constructor() {
		super();

		this.value = this.getAttribute("value");
		this.icon = this.getAttribute("icon") ?? "";
		this.variation = this.getAttribute("variation");
		this.iconColour = this.getAttribute("icon-colour");
		this.identifier = this.getAttribute("identifier") ?? "";
		this.link = this.getAttribute("link") ?? "";
		this.target = this.getAttribute("target");
		this.group = this.getAttribute("group");
		this.detached = this.hasAttribute("detached");
		this.download = this.getAttribute("download");
		this.helperText = this.getAttribute("helper-text") ?? "";
		this.suffixIcon = this.getAttribute("suffix-icon") ?? "";
	}

	parsedCallback() {
		if (this.icon) { this.prepend(document.createElementWithContents("chip-icon", null, { icon: this.icon, className: "dropdown-item__icon", colour: this.iconColour })); }
		if (this.helperText) { this.appendChild(document.createElementWithContents("span", this.helperText, { className: "dropdown-item__helper-text" })); }
		if (this.suffixIcon) { this.appendChild(document.createElementWithContents("chip-icon", null, { icon: this.suffixIcon, className: "dropdown-item__suffix-icon" })); }
	}

	attributeChanged(name, _, newValue) {
		switch (name) {
			case "disabled":
				if (!this.IsAttributeValueTrue(newValue)) {
					this.parentElement.removeAttribute("disabled");
				} else {
					this.parentElement.setAttribute("disabled", "");
				}
				break;
			case "link":
				if (this.parentElement.nodeName === "A") {
					this.parentElement.href = newValue;
				}
				break;
			case "suffix-icon":
				this.querySelector(":scope > .dropdown-item__suffix-icon")?.remove();

				if (newValue) {
					this.appendChild(document.createElementWithContents("chip-icon", null, { icon: newValue, className: "dropdown-item__suffix-icon" }));
				}
				break;
			case "icon":
				this.querySelector(":scope > .dropdown-item__icon")?.remove();

				if (newValue) {
					this.prepend(document.createElementWithContents("chip-icon", null, { icon: newValue, className: "dropdown-item__icon", colour: this.iconColour }));
				}
				break;
		}
	}
}